import { Component, OnInit } from '@angular/core';
import { BookmarkModel } from 'src/app/core/model/object/recipe-model';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';

@Component({
  selector: 'app-bookmarked-recipes',
  templateUrl: './bookmarked-recipes.component.html',
  styleUrls: ['./bookmarked-recipes.component.scss'],
})
export class BookmarkedRecipesComponent implements OnInit {
  bookmarks: BookmarkModel[] = [];

  dataIsReady = false;
  showLoading = false;

  constructor(
    private recipeService: RecipeService,
    private snackBarService: SnackBarService
  ) {
    this.getBookmaredRecipes();
  }

  ngOnInit() {}

  getBookmaredRecipes() {
    this.showLoading = true;
    this.recipeService.getBookmarkedRecipes().then((res) => {
      if (res.isSuccess()) {
        this.bookmarks = res.getData().getBookmarks();
        this.dataIsReady = true;
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
      this.showLoading = false;
    });
  }

  bookmark(bookmark: BookmarkModel) {
    this.showLoading = true;
    this.recipeService.bookmark(bookmark.recipe._id).then((res) => {
      if (res.isSuccess()) {
        this.bookmarks.splice(this.bookmarks.indexOf(bookmark), 1);
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
      this.showLoading = false;
    });
  }

  showDetail(recipeId: string) {
    this.recipeService.goToRecipeDetail(recipeId);
  }

  back() {
    this.recipeService.back();
  }
}
